import styled from '@emotion/styled'
import { DEFAULT_FOCUS_STYLES, DEFAULT_FONT_STYLES } from 'css/theme'
import { errorStyles, inputStyles } from 'css/utils'

type TokenexContainerProps = {
  focused: boolean
  errored: boolean
}

export const styles = {
  base: `
    background:transparent;
    border:none;
    outline:none;
    padding: 0;
    height: 100%;
    font-family: ${DEFAULT_FONT_STYLES['--theme-font--base-font-family']};
    font-size: ${DEFAULT_FONT_STYLES['--theme-font--body-default__font-size']};
    font-weight: ${DEFAULT_FONT_STYLES['--theme-font--body-default__font-weight']};
    line-height: ${DEFAULT_FONT_STYLES['--theme-font--body-lg__line-height']};
    width:100%;
    vertical-align: sub;
  `,
  cvv: {
    base: `
        color: rgba(26, 25, 25, 1);
        color-danger: #A90F0F;
        border:none;
        background:transparent;
        outline:none;
        font-family: ${DEFAULT_FONT_STYLES['--theme-font--base-font-family']};
        font-size: ${DEFAULT_FONT_STYLES['--theme-font--body-default__font-size']};
        font-weight: ${DEFAULT_FONT_STYLES['--theme-font--body-default__font-weight']};
        line-height: ${DEFAULT_FONT_STYLES['--theme-font--body-lg__line-height']};
        padding: 2px 0 0 0;
        height: 100%;
        width: 100%;`,
  },
}

const focusStyles = (props: TokenexContainerProps) => {
  const { focused } = props

  if (focused) {
    return {
      outline: DEFAULT_FOCUS_STYLES['--theme--focus-outline'],
      outlineOffset: '1px',
    }
  }

  return {}
}

export const TokenexContainer = styled.div(
  { height: '42px', position: 'relative', ...inputStyles },
  focusStyles,
  errorStyles,
)
